import { forwardRef, Module } from '@nestjs/common';
import {UserEntity} from './user.entity';
import {TypeOrmModule} from '@nestjs/typeorm';
import { UserService } from './user.service';
import { ProfileModule } from '../profile/profile.module';
import { HierarchyModule } from '../hierarchy/hierarchy.module';
import { PassportModule} from '../passport/passport.module';
import {JwtModule} from '@nestjs/jwt';
import { RolesEntity } from '../roles/roles.entity';
import { UserOtp } from './user-otp.entity';
@Module({
  imports: [ 
    TypeOrmModule.forFeature([UserEntity,RolesEntity,UserOtp]),
    forwardRef(()=>ProfileModule),
    forwardRef(() =>HierarchyModule),
    forwardRef(() => PassportModule.register({      
      defaultStrategy: 'jwt',      
      property: 'user',      
      session: false,    
    })),
    forwardRef(() =>JwtModule.register({
      secret: 'varaha',//process.env.SECRETKEY, 
      signOptions: {
        //  expiresIn: '1h',//process.env.EXPIRESIN,
      },
    })),
  ],
  providers: [UserService],
  exports: [UserService]
})
export class UserModule {}
